import { Options } from '@angular-slider/ngx-slider';
import { ChangeDetectorRef, Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ThermostatPreset, ThermostatPresetType } from '@app/modules/smart-devices/data/smart-devices.interface';
import { SmartDevicesService } from '@app/modules/smart-devices/service/smart-devices.service';
import { ThermostatSetupService } from '@app/modules/smart-devices/service/thermostat-setup.service';
import { sbnbIcon } from '@app/ui';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'sbnb-thermostat-preset-adjustment',
  templateUrl: './thermostat-preset-adjustment.component.html',
  styleUrls: ['./thermostat-preset-adjustment.component.scss'],
})
export class ThermostatPresetAdjustmentComponent implements OnInit, OnDestroy {
  @HostBinding('class') class = 'contents';
  @Input() config: {
    title: string;
    description?: string;
    icon: sbnbIcon;
    question: string;
    continueRoute: string;
    presetType: ThermostatPresetType;
  };
  options: Options = {
    floor: 50,
    ceil: 90,
    minLimit: 50,
    maxLimit: 90,
    minRange: 5,
    step: 0.05,
    hideLimitLabels: true,
    hidePointerLabels: true,
    animate: false,
    showOuterSelectionBars: true,
  };
  submitLoading = false;
  thermostatPreset: ThermostatPreset;

  private $destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private thermostatSetupService: ThermostatSetupService,
    private smartDevicesService: SmartDevicesService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.thermostatSetupService
      .thermostatPreset$(this.config.presetType)
      .pipe(takeUntil(this.$destroy$))
      .subscribe((preset) => {
        this.thermostatPreset = preset;
        this.cd.detectChanges();
      });
  }

  ngOnDestroy() {
    this.$destroy$.next();
  }

  onContinue() {
    if (!this.thermostatPreset) return;

    this.submitLoading = true;
    this.smartDevicesService
      .updateThermostatPreset(`${this.thermostatPreset.id}`, {
        heating_set_point_fahrenheit: Math.round(this.thermostatPreset.heating_set_point_fahrenheit),
        cooling_set_point_fahrenheit: Math.round(this.thermostatPreset.cooling_set_point_fahrenheit),
      })
      .pipe(finalize(() => (this.submitLoading = false)))
      .subscribe(() => this.router.navigate([`../${this.config.continueRoute}`], { relativeTo: this.route }));
  }
}
